import { cn } from "@/lib/utils";

type CodeOutputProps = {
  value?: string;
  placeholder?: string;
  className?: string;
};

export function CodeOutput({
  value,
  placeholder = "Output will appear here.",
  className,
}: CodeOutputProps) {
  if (!value) {
    return (
      <div className="flex min-h-40 items-center justify-center rounded-md border border-dashed border-zinc-300 bg-zinc-50 px-4 py-8 text-center text-sm text-zinc-500">
        {placeholder}
      </div>
    );
  }

  return (
    <pre
      className={cn(
        "max-h-[34rem] min-h-40 overflow-auto rounded-md border border-zinc-200 bg-zinc-950 p-4 font-mono text-sm leading-6 text-zinc-50",
        className,
      )}
    >
      <code>{value}</code>
    </pre>
  );
}
